import { datetimeFormatter, formatCoordinates } from '../../../shared/utils';
import '../DashboardTableGoodPractices.module.css'

type ExpandedRowDetailsProps = {
  row: any;
  colSpan: number;
  tableClassNames: string;
  handleShowMap: (lat: number, lng: number) => void;
};

const MISSING_VALUE = '---';

const ExpandedRowDetails = ({ row, colSpan, tableClassNames, handleShowMap }: ExpandedRowDetailsProps) => {
  const subColumnsTitles = ['Data/Hora', 'Localização'];
  const totalCols = colSpan;
  const emptyHeadersCount = totalCols - subColumnsTitles.length;
  const emptyCellsCount = totalCols - subColumnsTitles.length;

  return (
    <tr>
      <td colSpan={colSpan} style={{ padding: 0, margin: 0 }}>
        <table width='100%' className={tableClassNames}>
          <thead>
            <tr className='extendedRow'>
              {subColumnsTitles.map(col => (
                <th key={col} className='text-left'>
                  <span>{col}</span>
                </th>
              ))}
              {[...Array(emptyHeadersCount)].map((_, i) => (
                <th key={`empty-header-${i}`}></th>
              ))}
            </tr>
          </thead>
          <tbody>
            {row.items.map((item: any) => (
              <tr className='extendedRow' key={crypto.randomUUID()}>
                <td className='text-size-14' data-field='detailLastUpdate'>
                  {datetimeFormatter.format(new Date(item['detailLastUpdate' as keyof any]))}
                </td>
                <td className='text-size-14' data-field='coordinates'>
                  {item.detailEventCoordinates.lat != null && item.detailEventCoordinates.lng != null ? (
                    <button
                      className='btn'
                      style={{ backgroundColor: 'transparent' }}
                      onClick={() => handleShowMap(item.detailEventCoordinates.lat, item.detailEventCoordinates.lng)}
                    >
                      <span style={{marginLeft: -15}} className='rioglyph rioglyph-map-marker'></span>{' '}
                      {formatCoordinates(item.detailEventCoordinates.lat, item.detailEventCoordinates.lng)}
                    </button>
                  ) : (
                    MISSING_VALUE
                  )}
                </td>
                <td>
                  {item.detailEvents}
                </td>
                {[...Array(emptyCellsCount)].map((_, i) => (
                  <td key={`empty-cell-${i}`}></td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

export default ExpandedRowDetails;